import { Factory, Scroll } from "@phosphor-icons/react";
import clsx from "clsx";

export type ConnectionTypeChipsProps = {
    connectionTypeName?: string;
    connectionTypeChipColorHex?: string;
};

const ConnectionTypeChips = ({
    connectionTypeName,
    connectionTypeChipColorHex,
}: ConnectionTypeChipsProps) => {
    return (
        <>
            {connectionTypeName && connectionTypeChipColorHex && (
                <ConnectionTypeChip
                    name={connectionTypeName}
                    backgroundColorHex={connectionTypeChipColorHex}
                />
            )}
            {
                <ConnectionTypeChip
                    name="Manual"
                    backgroundColorHex="#ECF0EB"
                    className="!text-black"
                />
            }
        </>
    );
};

type ConnectionTypeChipProps = {
    name: string;
    backgroundColorHex: string;
    className?: string;
};

const getIconForName = (name: string) => {
    if (name === "Custom")
        return <Factory size="16" weight="light" className="block" />;
    if (name === "Manual")
        return <Scroll size="16" weight="regular" className="block" />;

    return <Factory size="16" weight="fill" className="block" />;
};

const ConnectionTypeChip = ({
    name,
    backgroundColorHex,
    className,
}: ConnectionTypeChipProps) => {
    return (
        <span
            className={clsx(
                "text-white text-xs rounded-md px-3 py-1 inline-flex items-center space-x-1",
                className
            )}
            style={{ backgroundColor: backgroundColorHex }}
        >
            {getIconForName(name)}
            <span className="block">{name}</span>
        </span>
    );
};

export default ConnectionTypeChips;
